/*
 * @Author       : 花裤衩(BYM)<yongming.bai@outlook.com>
 * @Date         : 2024-08-26 16:02:57 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-01-06 13:50:21 +0800
 * @FilePath     : /ai-agent-lumina/src/components/globalComponentsConfig.js
 * @Description  : 全局自定义组件装载器
 */
const  componentsRegistrar = async (app) => {
  const context = import.meta.glob('@/components/global/**/index.js', { eager: true });
  for (const path in context) {
    if (context.hasOwnProperty.call(context, path) && context[path] && context[path].default) {
      const component = context[path].default
      let name = (component.name || `izt-${component.__name}`) // 组件name或者文件名
      app.component(name, component)
    }
  }
}
export default componentsRegistrar